import React, { useContext } from 'react'
import { useAtom } from '@reatom/react'

import { DEFAULT_PAYWALL_VARIANT, PaywallVariantAtom } from '@bfg/atoms/PaywallVariant'

const PaywallVariantContext = React.createContext({
  variant: DEFAULT_PAYWALL_VARIANT,
  country: null,
  resolved: false
})

export function usePaywallVariant () {
  return useContext(PaywallVariantContext)
}

export function PaywallVariantProvider ({ children }) {
  const paywallVariantState = useAtom(PaywallVariantAtom)

  return (
    <PaywallVariantContext.Provider value={paywallVariantState}>
      {children}
    </PaywallVariantContext.Provider>
  )
}
